<template>
  <div class="heritage-page">
    <!-- 导航栏 -->
    <el-header class="header" height="80px">
      <div class="container">
        <div class="nav-content">
          <div class="logo-container">
            <div class="logo">
              <span class="logo-text">云锦录</span>
            </div>
          </div>
        </div>
      </div>
    </el-header>
<!--    <el-header class="header" height="80px">-->
<!--      <div class="container">-->
<!--        <div class="nav-content">-->
<!--          <div class="logo">-->
<!--            <span class="logo-text">云锦录</span>-->
<!--          </div>-->
<!--          <el-menu-->
<!--              :default-active="activeIndex"-->
<!--              class="nav-menu"-->
<!--              mode="horizontal"-->
<!--              background-color="transparent"-->
<!--              text-color="#333"-->
<!--              active-text-color="#B91C1C"-->
<!--          >-->
<!--            <el-menu-item index="1">首页</el-menu-item>-->
<!--            <el-menu-item index="2">非遗项目</el-menu-item>-->
<!--            <el-menu-item index="3">传承人</el-menu-item>-->
<!--            <el-menu-item index="4">展览活动</el-menu-item>-->
<!--            <el-menu-item index="5">关于我们</el-menu-item>-->
<!--          </el-menu>-->
<!--          <el-button type="danger" round class="apply-btn">申请保护</el-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-header>-->

    <el-main>
      <!-- 横幅区域 -->
      <section class="hero-section">
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <h1>传承千年匠心 守护文化瑰宝</h1>
          <p>探索中国非物质文化遗产的独特魅力，感受传统工艺的精湛技艺</p>
          <el-button type="danger" round size="medium" @click="handleJump">点击进入商城</el-button>
        </div>
      </section>

      <!-- 非遗门类 -->
      <section class="section">
        <div class="container">
          <h2 class="section-title">非遗门类</h2>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" v-for="(item, index) in categories" :key="index">
              <el-card class="category-card" :body-style="{ padding: '0px' }">
                <img :src="item.image" class="category-image" :alt="item.title">
                <div class="category-info">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.description }}</p>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 代表性传承人 -->
      <section class="section bg-gray">
        <div class="container">
          <h2 class="section-title">代表性传承人</h2>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" v-for="(master, index) in masters" :key="index">
              <el-card class="master-card">
                <img :src="master.image" class="master-image" :alt="master.name">
                <div class="master-info">
                  <h3>{{ master.name }}</h3>
                  <p class="title">{{ master.title }}</p>
                  <p class="description">{{ master.description }}</p>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 近期展览活动 -->
      <section class="section">
        <div class="container">
          <h2 class="section-title">近期展览活动</h2>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" v-for="(exhibition, index) in exhibitions" :key="index">
              <el-card class="exhibition-card">
                <div class="exhibition-content">
                  <div class="exhibition-image">
                    <img :src="exhibition.image" :alt="exhibition.title">
                  </div>
                  <div class="exhibition-info">
                    <h3>{{ exhibition.title }}</h3>
                    <p class="date">{{ exhibition.date }}</p>
                    <p class="description">{{ exhibition.description }}</p>
                    <el-button type="danger" round size="small">{{ exhibition.buttonText }}</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 保护与传承 -->
      <section class="section bg-gray">
        <div class="container">
          <h2 class="section-title">保护与传承</h2>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="8" v-for="(feature, index) in features" :key="index">
              <div class="feature-item">
                <div class="feature-icon">
                  <i :class="feature.icon"></i>
                </div>
                <h3>{{ feature.title }}</h3>
                <p>{{ feature.description }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
    </el-main>

<!--    &lt;!&ndash; 页脚 &ndash;&gt;-->
<!--    <el-footer class="footer">-->
<!--      <div class="container">-->
<!--        <el-row :gutter="20">-->
<!--          <el-col :xs="24" :sm="6">-->
<!--            <h4>关于我们</h4>-->
<!--            <p>致力于中国非物质文化遗产的保护、传承与发展。</p>-->
<!--          </el-col>-->
<!--          <el-col :xs="24" :sm="6">-->
<!--            <h4>联系方式</h4>-->
<!--            <p>电话：010-12345678</p>-->
<!--            <p>邮箱：info@heritage.org</p>-->
<!--          </el-col>-->
<!--          <el-col :xs="24" :sm="6">-->
<!--            <h4>关注我们</h4>-->
<!--            <div class="social-icons">-->
<!--              <el-button type="text" icon="el-icon-chat-dot-round" class="social-icon"></el-button>-->
<!--              <el-button type="text" icon="el-icon-share" class="social-icon"></el-button>-->
<!--              <el-button type="text" icon="el-icon-video-camera" class="social-icon"></el-button>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :xs="24" :sm="6">-->
<!--            <h4>订阅通讯</h4>-->
<!--            <el-input placeholder="请输入您的邮箱" v-model="email" class="subscribe-input">-->
<!--              <el-button slot="append" type="danger">订阅</el-button>-->
<!--            </el-input>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <div class="copyright">-->
<!--          <p>© {{ currentYear }} 中国非物质文化遗产保护中心 版权所有</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-footer>-->
  </div>
</template>

<script>
export default {
  name: 'HeritagePage',
  data() {
    return {
      activeIndex: '1',
      email: '',
      categories: [
        {
          title: '刺绣艺术',
          description: '千年传承的针线技艺，以丝线绣就人间最美的风景。',
          image: require('@/resource/show/1.png')
        },
        {
          title: '陶瓷制作',
          description: '泥土与火的艺术，塑造东方瓷器的典雅之美。',
          image: require('@/resource/show/2.png')
        },
        {
          title: '剪纸艺术',
          description: '一把剪刀，一张红纸，剪出中国人的喜庆与祝福。',
          image: require('@/resource/show/3.png')
        },
        {
          title: '书法艺术',
          description: '笔墨之间，传承中华文化的精神与气韵。',
          image: require('@/resource/show/4.png')
        }
      ],
      masters: [
        {
          name: '王德明',
          title: '苏州刺绣传承人',
          description: '从艺六十载，精研苏绣技艺，作品曾获多项国家级奖项。',
          image: require('@/resource/show/5.png')
        },
        {
          name: '张丽华',
          title: '景德镇陶瓷艺术大师',
          description: '专注青花瓷器创作三十年，作品被多家博物馆收藏。',
          image: require('@/resource/show/6.png')
        },
        {
          name: '李文才',
          title: '满族剪纸艺术传承人',
          description: '深耕满族剪纸艺术四十余年，致力于技艺传承与创新。',
          image: require('@/resource/show/7.png')
        }
      ],
      exhibitions: [
        {
          title: '匠心传承展',
          date: '2024 年 3 月 15 日 - 4 月 15 日',
          description: '展出百余件非遗传承人精品力作，展现传统工艺的当代魅力。',
          buttonText: '预约参观',
          image: require('@/resource/show/8.png')
        },
        {
          title: '非遗技艺体验课',
          date: '每周六、日 14:00 - 16:00',
          description: '跟随非遗传承人学习传统工艺，感受匠人精神。',
          buttonText: '立即报名',
          image: require('@/resource/show/9.png')
        }
      ],
      features: [
        {
          title: '档案建设',
          description: '建立完善的非遗数字档案，为传统文化保护提供重要依据。',
          icon: 'el-icon-notebook-2'
        },
        {
          title: '人才培养',
          description: '设立非遗传承人培养计划，确保技艺代代相传。',
          icon: 'el-icon-user'
        },
        {
          title: '文化传播',
          description: '通过展览、讲座等形式，扩大非遗文化的社会影响力。',
          icon: 'el-icon-share'
        }
      ]
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    handleJump() {
      this.$router.push('/show')
    }
  }
}
</script>

<style scoped>
.heritage-page {
  font-family: "Microsoft YaHei", "SimSun", sans-serif;
  color: #333;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 头部样式 */
.header {
  position: fixed;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.nav-content {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100%;
}

.logo-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.logo {
  font-size: 24px;
  font-weight: bold;
}

.logo-text {
  font-family: 'Pacifico', cursive;
  color: #B91C1C;
}

.nav-menu {
  border-bottom: none;
}

.el-menu-item {
  font-size: 16px;
  margin: 0 10px;
}

.apply-btn {
  margin-left: 20px;
}

/* 横幅区域 */
.hero-section {
  height: 600px;
  position: relative;
  background-image: url('@/resource/show/banner.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  margin-top: 80px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  color: white;
  padding: 0 80px;
}

.hero-content h1 {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 20px;
  margin-bottom: 30px;
}

/* 通用区域样式 */
.section {
  padding: 60px 0;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #B91C1C;
}

.bg-gray {
  background-color: #f5f5f5;
}

/* 分类卡片 */
.category-card {
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.category-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.category-card:hover .category-image {
  transform: scale(1.05);
}

.category-info {
  padding: 20px;
}

.category-info h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.category-info p {
  color: #666;
}

/* 传承人卡片 */
.master-card {
  margin-bottom: 20px;
}

.master-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.master-info {
  padding: 20px;
}

.master-info h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
}

.master-info .title {
  color: #666;
  margin-bottom: 10px;
}

.master-info .description {
  color: #888;
}

/* 展览卡片 */
.exhibition-card {
  margin-bottom: 20px;
}

.exhibition-content {
  display: flex;
}

.exhibition-image {
  width: 40%;
}

.exhibition-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.exhibition-info {
  width: 60%;
  padding: 20px;
}

.exhibition-info h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
}

.exhibition-info .date {
  color: #666;
  margin-bottom: 10px;
}

.exhibition-info .description {
  color: #888;
  margin-bottom: 15px;
}

/* 特性区域 */
.feature-item {
  text-align: center;
  padding: 20px;
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background-color: #B91C1C;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon i {
  font-size: 30px;
  color: white;
}

.feature-item h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.feature-item p {
  color: #666;
}

/* 页脚样式 */
.footer {
  background-color: #222;
  color: white;
  padding: 60px 0 20px;
}

.footer h4 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #fff;
}

.footer p {
  color: #aaa;
  margin-bottom: 10px;
}

.social-icons {
  display: flex;
}

.social-icon {
  font-size: 24px;
  color: #aaa;
  margin-right: 15px;
}

.social-icon:hover {
  color: #B91C1C;
}

.subscribe-input {
  margin-bottom: 20px;
}

.copyright {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #444;
  color: #777;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 36px;
  }

  .hero-content p {
    font-size: 16px;
  }

  .exhibition-content {
    flex-direction: column;
  }

  .exhibition-image, .exhibition-info {
    width: 100%;
  }

  .exhibition-image {
    height: 200px;
  }

  .nav-content {
    flex-direction: column;
    padding: 10px 0;
  }

  .nav-menu {
    margin: 10px 0;
  }

  .apply-btn {
    margin: 10px 0 0 0;
  }
}
</style>